import type { ProductFormValues } from './api';

/**
 * "Duplikuj produkt": the new card starts from a copy of an existing product's
 * card values and every field stays editable, e.g. "Fibrex Interior" →
 * "Fibrex Exterior" (same dimensions, weight and „Liczymy tylko w sztukach”,
 * different EAN and price).
 *
 * Not copied: the EAN (it identifies the physical product, so the copy needs
 * its own), the average cost (the copy is priced on its own) and the variants
 * with their cost overrides (variants are added on the saved copy). The copy
 * is always active.
 */
export function toProductCopyFormValues(source: ProductFormValues, copyName: string): ProductFormValues {
  return {
    ...source,
    name: copyName,
    ean: null,
    isActive: true,
    averagePurchasePricePLN: null,
    variantCosts: {},
  };
}
